import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { HouseDataProvider } from "../../data-provider/house.dp";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { Campaign } from "../../models/campaign.model";
import { Filter } from "../../models/filter.model";
import { House } from "../../models/house.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { StreetDataProvider } from "../../data-provider/street.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { Utils } from "../../helper/utils.helper";

export class PeopleController {
    // * bindings for typescript compiler *
    public doubleToolbar?: any;
    // ************************************

    public previousTab: string | null = null;
    public personLink = true;
    public progressContentStatus = false;
    public active_tab = "people";
    public testPermission = false;
    public isLeaderView: boolean;
    public selectedStreet: any;
    public selectedGroup: any;
    public hoid: any;
    public showTabs = false;
    public activeCampaign: Campaign;
    public consentSettings: any;
    public consentSettingsDisabled: any;
    public filter: Filter;

    private $scope: any;
    private $cookies: any;
    private $q: any;
    private $location: any;
    private dialog: DialogUtils;
    private $route: any;
    private __app_type: string;
    private __env: any;
    private utils: Utils;
    private screen: ScreenUtils;

    public permissionProvider: PermissionCheck;
    public navigationBarService: NavigationBarHelperService;
    public houseDataProvider: HouseDataProvider;
    public houseOccupantDataProvider: HouseOccupantDataProvider;
    public streetDataProvider: StreetDataProvider;
    public groupDataProvider: GroupDataProvider;
    public filterDataProvider: FilterDataProvider;
    public campaignDataProvider: CampaignDataProvider;
    public linkOrigin: string;

    constructor(
        $scope: any,
        $cookies: any,
        $q: any,
        $location: any,
        $route,
        __env: any,
        __app_type: string,
        NavigationBarHelperService: NavigationBarHelperService,
        HouseDataProvider: HouseDataProvider,
        HouseOccupantDataProvider: HouseOccupantDataProvider,
        StreetDataProvider: StreetDataProvider,
        GroupDataProvider: GroupDataProvider,
        FilterDataProvider: FilterDataProvider,
        CampaignDataProvider: CampaignDataProvider,
        PermissionCheck: PermissionCheck,
        Utils: Utils,
        ScreenUtils: ScreenUtils,
        DialogUtils: DialogUtils
    ) {
        this.$scope = $scope;
        this.$cookies = $cookies;
        this.$q = $q;
        this.$location = $location;
        this.dialog = DialogUtils;
        this.$route = $route;
        this.__app_type = __app_type;
        this.__env = __env;
        this.utils = Utils;
        this.screen = ScreenUtils;

        this.permissionProvider = PermissionCheck;
        this.navigationBarService = NavigationBarHelperService;
        this.houseDataProvider = HouseDataProvider;
        this.houseOccupantDataProvider = HouseOccupantDataProvider;
        this.streetDataProvider = StreetDataProvider;
        this.groupDataProvider = GroupDataProvider;
        this.filter = new Filter();
        this.filterDataProvider = FilterDataProvider;
        this.campaignDataProvider = CampaignDataProvider;

        this.utils.runWootric();
        this.utils.accessCheck();
        this.isLeaderView = this.__app_type === "LEADER";

        let searchPath = this.$location.search();
        this.active_tab = searchPath.tab || "people";
        this.selectedStreet = searchPath.street
            ? JSON.parse(searchPath.street)
            : null;

        this.selectedGroup = searchPath.group
            ? JSON.parse(searchPath.group)
            : null;

        this.linkOrigin = searchPath.origin ?? null;

        this.hoid = searchPath.hoid;

        this.showTabs = false;
        this.activeCampaign = this.campaignDataProvider.activeCampaign;

        this.permissionProvider.getConsentSettings().then((consentSettings) => {
            this.consentSettings = consentSettings;
            this.consentSettingsDisabled =
                this.permissionProvider.consentSettingsDisabled(
                    consentSettings.SIGNATURE,
                    consentSettings,
                    this.activeCampaign
                );
        });
    }

    tabChanged(tabname: string) {
        this.previousTab = tabname;
        this.selectedGroup = {};
        this.selectedStreet = null;
        this.$location.search("tab", tabname);
        this.$location.search("street", null);
        this.$location.search("group", null);
    }

    openHouseDialog(ev: any): void {
        this.dialog
            .show({
                component: "vc-house-form",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: false,
                scope: this.$scope,
                locals: {
                    selectedHouse: null,
                },
                size: "x-large",
            })
            .then((editedHouse: House) => {
                this.houseDataProvider.addToFilteredHouses(editedHouse);
            });
    }
}

angular.module("people").controller("PeopleController", PeopleController);
